import { B5, Stack } from '@zet/design-system'

const FormValidationErrorMessage = ({ error }: { error?: string }) => {
  if (!error) {
    return <></>
  }

  return (
    <Stack className="mt-2">
      <B5 className="text-error-100">{error}</B5>
    </Stack>
  )
}

export default FormValidationErrorMessage
